var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Question',{attrs:{"uuid":_vm.uuid,"timeout":_vm.timeout,"image":_vm.imageFile,"disabled":_vm.disabled},on:{"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }